export default [
  {
    fullName: 'НАТАЛИЯ СИДЯКИНА',
    jobTitle: '<a href="https://t.me/Natalia_iolve" target=@Natalia_iolve"_blank">Ведущий продюсер</a>',
    description: 'С 2017 года занимается продюсированием мероприятий. Опыт Натальи включает продюсирование съемок на таких больших мероприятиях, как AI Journey, PHD Hack Days, ПМЭФ',
    photo: require('@/assets/speakers/speaker-1.jpg')
  },
  {
    fullName: 'ДМИТРИЙ ДАНИЛИН',
    jobTitle: '<a href="https://t.me/Dimabig77" target="_blank">Продюсер</a>',
    description: 'Настоящий продюсер (подготовлен во ВГИК). Имеет пятилетный опыт работ в съемках сериалов, рекламы, онлайн-мероприятий.',
    photo: require('@/assets/speakers/speaker-2.jpg')
  },
  {
    fullName: 'РОМАН КОВАНЬКО',
    jobTitle: '<a href="https://t.me/kovanko" target="_blank">Коммерческий директор</a>',
    description: 'С 2018 года занимается организацией мероприятий.',
    photo: require('@/assets/speakers/speaker-3.jpg')
  },
  {
    fullName: 'АННА ГАЛКИНА',
    jobTitle: '<a href="https://t.me/amenglebey" target="_blank" Менеджер по развитию бизнеса</a>',
    description: 'Многолетний опыт работы с клиентами сегмента enterprise',
    photo: require('@/assets/speakers/speaker-4.jpg')
  }
]
